import { createSlice, isAnyOf, PayloadAction } from '@reduxjs/toolkit'
import { l } from '@manychat/manyui'

import { ISelectedApplicationState } from 'common/actions/integrations/Applications/interfaces'
import { alert } from 'common/core'
import { ApplicationsApi } from 'shared/api/requests/applications'
import { createAsyncAction } from 'shared/lib/redux'

import { fetchApplications } from './applications'

const initialState: ISelectedApplicationState = {
  applicationId: null,
  fetching: false,
}

export const publishApplication = createAsyncAction(
  'application/publish',
  async (payload: { app_id: number; changelog: string }, { dispatch }) => {
    await ApplicationsApi.publish({ body: payload })

    dispatch(fetchApplications())
    dispatch(closeModal())
    alert(l.translate('The application was sent to review'), 'success')
  },
)

const publishSlice = createSlice({
  name: 'application/publish',
  initialState,
  reducers: {
    closeModal(state) {
      state.applicationId = null
    },
    openModal(state, action: PayloadAction<number>) {
      state.applicationId = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(publishApplication.pending, (state) => {
      state.fetching = true
    })
    builder.addMatcher(
      isAnyOf(publishApplication.rejected, publishApplication.fulfilled),
      (state) => {
        state.fetching = false
      },
    )
  },
})

export const { closeModal, openModal } = publishSlice.actions

export const { reducer } = publishSlice
